/* @flow */
import React from 'react'
import Select from 'antd/lib/select'

export type MultiselectOption = {
  key: string,
  value: string,
  text: string
}

export type OnSelectChange = (name: string) => (value: Array<string>) => void

type Props = {
  name: string,
  placeholder: string,
  value: Array<string>,
  options: Array<MultiselectOption>,
  onChange: OnSelectChange
}

const MultiSelect = ( { name, placeholder, value, options, onChange }: Props ) => (
  <Select
    mode="multiple"
    style={{ width: '100%' }}
    placeholder={placeholder}
    defaultValue={value}
    onChange={onChange(name)}
  >
  {options.map(option => <Select.Option key={option.key}>{option.text}</Select.Option>)}
  </Select>
)

export default MultiSelect



// WEBPACK FOOTER //
// ./src/MultiSelect.js